/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const FavoriteRecipeRowSkeletonMobile = (props) => (
    <ContentLoader
        width={"100%"}
        height={230}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{backgroundColor: "#fff", borderRadius: "4px", marginBottom: "12px"}}
        {...props}>

        {/* Thumbnail image */}
        <rect x="16" y="16" width="80" height="80"/>

        {/* Title */}
        <rect x="116" y="51" rx="3" ry="3" width="25%" height="10"/>

        {/* Favorite button */}
        <circle cx={`calc(100% - 34px)`} cy="40" r="24"/>

        {/* Category 1 */}
        <rect x="20%" y="116" rx="3" ry="3" width="20%" height="10"/>
        <rect x="25%" y="136" rx="3" ry="3" width="10%" height="10"/>

        {/* Category 2 */}
        <rect x="60%" y="116" rx="3" ry="3" width="20%" height="10"/>
        <rect x="65%" y="136" rx="3" ry="3" width="10%" height="10"/>

        {/* Category 3 */}
        <rect x="40%" y="180" rx="3" ry="3" width="20%" height="10"/>
        <rect x="45%" y="200" rx="3" ry="3" width="10%" height="10"/>

    </ContentLoader>
);
